import React from 'react';
import './WhyCognitva.css';
import siteConfig from '../../configuration/siteConfiguration';

const features = [
  {
    "title": "Patent-Pending Intelligence Architecture",
    "description": "Modular, reusable AI stack powering Legal, Health, FinTech and Compliance copilots — engineered for scale across domains.",
    "icon": "patent-pending-intelligence-architecture.svg"

  },
  {
    "title": "Semantic + Predictive AI",
    "description": "Fuses natural language understanding with real-time data modeling for smart, context-aware decisions.",
    "icon": "semantic--predictive-ai.svg"
  },
  {
    "title": "Domain-Aware Automation",
    "description": "Pre-trained on regulatory, clinical, financial and legal logic — with workflows built for how professionals actually work.",
    "icon": "domain-aware-automation.svg"
  },
  {
    "title": "Faster Time-to-Impact",
    "description": "80% code and logic reuse across industries allows for plug-and-play deployment, reducing integration time and cost.",
    "icon": "faster-time-to-impact.svg"
  },
  {
    "title": "Human + AI Collaboration",
    "description": "Our agentic engines don't replace experts — they empower them to do more with less friction.",
    "icon": "human--ai-collaboration.svg"
  },
  {
    "title": "Simple to Deploy",
    "description": "Cloud-native, API-ready, and platform-agnostic — deploy within existing systems without disrupting your operations.",
    "icon": "simple-to-deploy.svg"
  },
  {
    "title": "Built on Trust",
    "description": "Transparent AI with audit-ready logic and explainable workflows for defensible decisions.",
    "icon": "built-on-trust.svg"
  },
  {
    "title": "Engineered for Accuracy",
    "description": "Trained on curated, validated datasets with continuous feedback loops to minimize hallucinations.",
    "icon": "engineered-for-accuracy.svg"
  },
  {
    "title": "Enterprise-Grade Security",
    "description": "End-to-end encryption, role-based access control, and full compliance with healthcare, legal, financial and IT security standards (HIPAA, GDPR, ISO/IEC 27001-ready).",
    "icon": "enterprise-grade-security.svg"
  }
];

const WhyCognitva = () => {
  return (
    <section className="why-cognitva-section">
      <div className="wave-bg">
        <img src="/images/wave.svg" alt="" />
      </div>
      <div className="why-cognitva-container">
        <div className="why-cognitva-header">
          <div className="why-cognitva-intro">
            <div className="why-cognitva-line"></div>
            <span className="why-cognitva-badge">WHY COGNITVA</span>
          </div>
          <h2 className="why-cognitva-title">AI that Understands. Automates. Elevates.</h2>
          <p className="why-cognitva-description">
            Cognitva is not just another AI platform. We're building the next-generation Cross-Industry Intelligence Platform (CIP™) — where deep semantic
            understanding meets domain-specific automation. Whether you're navigating complex legal processes, clinical diagnostics, or regulatory compliance,
            <strong>Cognitva orchestrates intelligent outcomes at scale.</strong>
          </p>
          <p className="why-cognitva-sub-description">Built for complexity. Designed for action.</p>
        </div>

        <div className="why-cognitva-grid">
          {features.map((feature, index) => (
            <div className="why-cognitva-card" key={index}>
              <div className="why-cognitva-icon-container">
                <img src={`${siteConfig.assetBaseUrl}/icons/homepage/why-cognitva/${feature.icon}`} alt="icon" className="why-cognitva-icon" />
              </div>
              <h3 className="why-cognitva-card-title">{feature.title}</h3>
              <p className="why-cognitva-card-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyCognitva; 